<app-navbar></app-navbar>

<div class="dashboard-full-width">
    <div class="">
        <div class="main-container-dashboard">


            <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->


            <div class="dashboard-container-right">
                <div class="main-container">
                    <div class="row">
                        <div class="card shadow m-3" style="width: 100%">
                            <div class="card-header ">
                                <h4>Sample Center Users Activities</h4>
                            </div>
                            <div class="card-body">

                                <div class="col-lg-12 ">
                                    <div class=" table-responsive">

                                        <table
                                            class="table table-bordered table-condensed table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
                                            datatable [dtOptions]="dtOptions" width="100%">
                                            <thead class="">
                                                <tr>
                                                    <th>S/N</th>
                                                    <th>Name</th>
                                                    <th>Action taken</th>
                                                    <th>Date Stamp</th>
                                                </tr>
                                            </thead>
                                            <tbody class="dashboard-bg-white">
                                                <tr>
                                                    <th>1</th>
                                                    <td>Waelchi, Hane and Schoen</td>
                                                    <td>Added Sample</td>
                                                    <td>Jun 10, 2021</td>
                                                </tr>
                                                <tr>
                                                    <th>2</th>
                                                    <td>Waelchi, Hane and Schoen</td>
                                                    <td>Created Passengers</td>
                                                    <td>Jun 10, 2021</td>
                                                </tr>
                                                <tr>
                                                    <th>3</th>
                                                    <td>Waelchi, Hane and Schoen</td>
                                                    <td>Ran Test</td>
                                                    <td>Jun 10, 2021</td>
                                                </tr>
                                                <tr>
                                                    <th>5</th>
                                                    <td>Waelchi, Hane and Schoen</td>
                                                    <td>Added Users</td>
                                                    <td>Jun 10, 2021</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <app-footer-dashboard></app-footer-dashboard>